'use client';

import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import { cn } from '@ncai-axe/react-ui-v3';
import * as RadioGroupPrimitive from '@radix-ui/react-radio-group';
import { Circle } from 'lucide-react';
import styles from './styles.module.scss';
const RadioGroupRoot = t0 => {
  const $ = _c(8);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  const t1 = props.orientation;
  let t2;
  if ($[3] !== className) {
    t2 = cn(styles.radioGroup, className);
    $[3] = className;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== props || $[6] !== t2) {
    t3 = <RadioGroupPrimitive.Root orientation={t1} className={t2} {...props} />;
    $[5] = props;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};
type RadioGroupItemProps = React.ComponentPropsWithRef<typeof RadioGroupPrimitive.Item> & {
  size?: 'small' | 'medium';
};
const RadioGroupItem = t0 => {
  const $ = _c(15);
  let className;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      className,
      size: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = t1;
  } else {
    className = $[1];
    props = $[2];
    t1 = $[3];
  }
  const size = t1 === undefined ? "medium" : t1;
  const t2 = styles[size];
  let t3;
  if ($[4] !== className || $[5] !== t2) {
    t3 = cn(styles.radioGroupItem, t2, className);
    $[4] = className;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const t4 = styles[size];
  let t5;
  if ($[7] !== t4) {
    t5 = cn(styles.circleIcon, t4);
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t5) {
    t6 = <RadioGroupPrimitive.Indicator className={styles.radioGroupItemIndicator}><Circle className={t5} stroke="none" /></RadioGroupPrimitive.Indicator>;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== props || $[12] !== t3 || $[13] !== t6) {
    t7 = <RadioGroupPrimitive.Item className={t3} {...props}>{t6}</RadioGroupPrimitive.Item>;
    $[11] = props;
    $[12] = t3;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
};
RadioGroupItem.displayName = RadioGroupPrimitive.Item.displayName;
export { RadioGroupRoot, RadioGroupItem };